import {
  Skeleton as AntdSkeleton,
  SkeletonProps as AntdSkeletonProps,
} from "antd";
import React from "react";

export type SkeletonProps = AntdSkeletonProps;

const Skeleton = (props: SkeletonProps) => {
  return <AntdSkeleton {...props} />;
};

export default Skeleton;
